export const MAPPING_TOKEN_LEGEND_TITLE = "Legenda token mapping colonne";
export const MAPPING_STATE_LEGEND_TITLE = "Legenda stati mapping";
export const IMPORT_STATUS_LEGEND_TITLE = "Legenda stati ultimo import";
export const FEED_FORMAT_LEGEND_TITLE = "Legenda formati feed";

export const SKIP_FIELD_TOKEN = "skip";

const MAPPING_STATUS_DISPLAY = {
  none: "NONE",
  auto: "AUTO",
  auto_warn: "AUTO_WARN",
  auto_err: "AUTO_ERR",
  manual: "MANUAL",
  manual_warn: "MANUAL_WARN",
  manual_err: "MANUAL_ERR",
};

export const normalizeMappingStateKey = (state) => {
  const normalized = String(state || "none").trim().toLowerCase().replace(/-/g, "_");
  return normalized || "none";
};

export const formatMappingStateValue = (state) => {
  const key = normalizeMappingStateKey(state);
  if (MAPPING_STATUS_DISPLAY[key]) {
    return MAPPING_STATUS_DISPLAY[key];
  }
  return key.toUpperCase();
};

export const formatImportStatusValue = (status) => status || "N/D";

export const MAPPING_STATE_LEGEND = [
  {
    value: "NONE",
    description: "Nessun mapping salvato o mapping vuoto.",
  },
  {
    value: "AUTO",
    description: "Mapping auto-generato e considerato valido (campi obbligatori presenti, nessun avviso).",
  },
  {
    value: "AUTO_WARN",
    description: "Mapping auto-generato completo ma con avvisi (es. categoria o immagini mancanti).",
  },
  {
    value: "AUTO_ERR",
    description: "Mapping auto-generato incompleto o con errori bloccanti.",
  },
  {
    value: "MANUAL",
    description: "Mapping salvato manualmente dall'operatore, valido senza avvisi.",
  },
  {
    value: "MANUAL_WARN",
    description: "Mapping manuale completo ma con avvisi di validazione import.",
  },
  {
    value: "MANUAL_ERR",
    description: "Mapping manuale incompleto o con errori di validazione bloccanti.",
  },
];

export const FEED_FORMAT_LEGEND = [
  {
    value: "AUTO",
    description: "Rilevamento automatico del formato.",
  },
  {
    value: "XML",
    description: "Feed strutturato in XML.",
  },
  {
    value: "EXCEL",
    description: "Foglio Excel (.xls/.xlsx).",
  },
  {
    value: "CSV_COMMA",
    description: "CSV con separatore virgola (,).",
  },
  {
    value: "CSV_COMMA_QUOTED",
    description: "CSV virgola con tutti i campi quotati RFC (descrizioni con virgole interne).",
  },
  {
    value: "CSV_SEMICOLON",
    description: "CSV con separatore punto e virgola (;).",
  },
  {
    value: "CSV_SEMICOLON_MULTILINE",
    description: "CSV punto e virgola con righe di continuazione che iniziano per (;).",
  },
  {
    value: "CSV_SEMICOLON_QUOTED",
    description: "CSV punto e virgola con campi quotati RFC.",
  },
  {
    value: "CSV_TAB",
    description: "CSV con separatore tab (\\t).",
  },
  {
    value: "CSV_TAB_QUOTED",
    description: "CSV tab con campi quotati RFC.",
  },
  {
    value: "CSV_PIPE",
    description: "CSV pipe (|) semplice, split letterale (es. misure 12\" nel nome).",
  },
  {
    value: "CSV_PIPE_QUOTED",
    description: "CSV pipe (|) con campi quotati RFC e pipe interne al valore.",
  },
  {
    value: "CSV_PIPE_ENDRECORD",
    description: "CSV pipe (|) con delimitatore <endrecord> e campi quotati.",
  },
];

export const IMPORT_STATUS_LEGEND = [
  {
    value: "COMPLETED",
    description: "Import terminato senza errori.",
  },
  {
    value: "COMPLETED_WITH_WARNINGS",
    description: "Import terminato con warning su singoli prodotti (es. immagine mancante).",
  },
  {
    value: "COMPLETED_WITH_ERRORS",
    description: "Import terminato con errori bloccanti su singoli prodotti.",
  },
  {
    value: "MAPPING_REVIEW",
    description: "Import bloccato: mapping incompleto o da revisionare.",
  },
  {
    value: "FAILED",
    description: "Import fallito.",
  },
  {
    value: "DOWNLOAD_FAILED",
    description: "Download feed fallito.",
  },
  {
    value: "PARSE_FAILED",
    description: "Parsing feed fallito.",
  },
  {
    value: "CANCELLED",
    description: "Import annullato.",
  },
];

export const MAPPING_FIELD_LEGEND = {
  skip: "Ignora la colonna feed: il valore non entra nel modello canonico di import.",
  name: "Nome o titolo commerciale del prodotto. Obbligatorio per la validazione import.",
  description: "Descrizione testuale del prodotto; HTML di base viene ripulito in import.",
  description_1: "Primo segmento descrizione (modalita livelli distinti, join con |).",
  description_2: "Secondo segmento descrizione.",
  description_3: "Terzo segmento descrizione.",
  description_4: "Quarto segmento descrizione.",
  description_5: "Quinto segmento descrizione.",
  brand: "Marca o produttore del prodotto.",
  price: "Prezzo di listino o di riferimento. Usato con special_price per calcolare prezzo_di_riferimento.",
  special_price: "Prezzo scontato o prezzo finale di vendita. Se assente, il listino price diventa prezzo_vendita.",
  internal_code: "Codice interno, SKU o id prodotto del vendor. Obbligatorio mappare almeno uno tra internal_code e ean_code.",
  ean_code: "Codice EAN, GTIN, barcode o MINSAN. Obbligatorio mappare almeno uno tra internal_code e ean_code.",
  product_url: "URL della pagina prodotto sul sito vendor. Obbligatorio nel mapping; in import deve essere un URL http(s) valido (DB catalog.link_offerta).",
  category: "Categoria singola del feed: il valore viene salvato cosi com'e, senza normalizzare separatori di path.",
  category_path: "Percorso completo categorie dal feed: salvato cosi com'e in catalog.albero_categorie (nessuna normalizzazione separatori).",
  category_1: "Primo livello dell'albero categorie vendor (modalita livelli distinti).",
  category_2: "Secondo livello dell'albero categorie vendor.",
  category_3: "Terzo livello dell'albero categorie vendor.",
  category_4: "Quarto livello dell'albero categorie vendor.",
  category_5: "Quinto livello dell'albero categorie vendor.",
  category_6: "Sesto livello dell'albero categorie vendor.",
  product_type: "Tipologia commerciale legacy (preferire category_path o category_1..6).",
  google_product_category: "Categoria Google Merchant: in auto-map viene preferito category_path quando possibile.",
  image_path: "Immagine principale del prodotto (URL). Primo slot immagine in import.",
  image_path_1: "Seconda immagine prodotto (URL).",
  image_path_2: "Terza immagine prodotto (URL).",
  shipping_price: "Costo spedizione associato all'offerta; mappa la colonna feed o imposta column_defaults.shipping_price (DB catalog.spese_di_spedizione).",
  availability: "Disponibilita o stock: quantita numerica, in stock/out of stock o valori testuali equivalenti.",
  weight: "Peso prodotto per scheda tecnica o spedizione.",
  department: "Reparto commerciale di alto livello nel feed vendor.",
  section: "Sezione di catalogo intermedia nel feed vendor.",
};

/** Colonne DB di destinazione dopo sync catalog_output (product + catalog). */
export const MAPPING_TOKEN_DB_COLUMNS = {
  skip: null,
  name: "product.nome",
  description: "catalog.descrizione",
  description_1: "catalog.descrizione",
  description_2: "catalog.descrizione",
  description_3: "catalog.descrizione",
  description_4: "catalog.descrizione",
  description_5: "catalog.descrizione",
  brand: "product.marca",
  price: "catalog.prezzo_di_riferimento",
  special_price: "catalog.prezzo_vendita",
  internal_code: "product.codice_prodotto, catalog.codice_interno",
  ean_code: "catalog.codice_ean",
  product_url: "catalog.link_offerta",
  category: "catalog.albero_categorie",
  category_path: "catalog.albero_categorie",
  category_1: "catalog.albero_categorie",
  category_2: "catalog.albero_categorie",
  category_3: "catalog.albero_categorie",
  category_4: "catalog.albero_categorie",
  category_5: "catalog.albero_categorie",
  category_6: "catalog.albero_categorie",
  product_type: "catalog.albero_categorie",
  google_product_category: "catalog.albero_categorie",
  image_path: "catalog.link_immagine",
  image_path_1: "catalog.link_immagine_1",
  image_path_2: "catalog.link_immagine_2",
  shipping_price: "catalog.spese_di_spedizione",
  availability: "catalog.disponibilita",
  weight: "product.peso",
  department: "catalog.albero_categorie",
  section: "catalog.albero_categorie",
};

const mappingLegendDescription = (token) => {
  const base = MAPPING_FIELD_LEGEND[token]
    || "Campo mappabile verso il modello canonico di import catalogo.";
  const dbColumns = MAPPING_TOKEN_DB_COLUMNS[token];
  if (!dbColumns) {
    return base;
  }
  return `${base} Destinazione DB: ${dbColumns}.`;
};

export const IMPORT_ISSUES_LEGEND_TITLE = "Errori e warning import riga";
export const MAPPING_VALIDATION_LEGEND_TITLE = "Errori e warning validazione mapping";

/** Messaggi prodotti da business_rules e import_result_data (solo import, non mapping). */
export const IMPORT_ISSUES_LEGEND = [
  {
    value: "titolo mancante",
    description:
      "ERRORE import riga (business). Dopo il mapping name/title e vuoto: la riga e segnalata in rosso "
      + "(campo name, DB product.nome). Il record viene scritto in DB ma disattivato (isdisattivato=1). "
      + "Contribuisce a COMPLETED_WITH_ERRORS. Non revoca una categorizzazione gia certificata.",
  },
  {
    value: "prezzo mancante o uguale a 0",
    description:
      "ERRORE import riga (business). Nessun prezzo valido su price o special_price: "
      + "la riga e segnalata in rosso (campo price). Il record viene scritto in DB ma disattivato. "
      + "Contribuisce a COMPLETED_WITH_ERRORS.",
  },
  {
    value: "immagine mancante",
    description:
      "WARNING import riga (business). Nessun URL valido su image_path, image_path_1 o image_path_2: "
      + "la riga resta attiva in catalogo ma e segnalata in giallo. Contribuisce a COMPLETED_WITH_WARNINGS.",
  },
  {
    value: "product_url mancante",
    description:
      "ERRORE import riga (identita). URL prodotto assente o vuoto dopo normalizzazione: "
      + "la riga NON viene importata (campo product_url). Il catalogo DB corrispondente, se esiste, "
      + "non viene aggiornato e puo essere disattivato a fine import se assente da seen_catalog_ids.",
  },
  {
    value: "product_url non valido",
    description:
      "ERRORE import riga (identita). Il valore mappato a product_url non e un URL http(s) valido "
      + "(serve schema http/https e host). Blocca l'import della riga come product_url mancante.",
  },
  {
    value: "identificatore mancante",
    description:
      "ERRORE import riga (identita). Mancano sia internal_code sia ean_code nel feed mappato. "
      + "Blocca la riga; nessun INSERT/UPDATE. Evidenzia internal_code e ean_code.",
  },
  {
    value: "codice prodotto non generabile",
    description:
      "ERRORE import riga (identita). Impossibile costruire INT-/EAN- dagli identificatori feed. "
      + "Blocca la riga; nessun INSERT/UPDATE.",
  },
  {
    value: "identificatore incoerente con codice prodotto",
    description:
      "ERRORE import riga (identita). Match su catalogo esistente ma codice_prodotto in DB "
      + "(non legacy URL-*) non corrisponde agli identificatori feed. Blocca la riga; "
      + "tipico dopo cutover se il codice in DB non e stato rigenerato.",
  },
  {
    value: "match identita ambiguo",
    description:
      "ERRORE import riga (identita). Lo stesso internal_code o ean_code del feed matcha piu cataloghi attivi. "
      + "Blocca la riga finche l'ambiguita non e risolta.",
  },
  {
    value: "inserimento non consentito su catalogo esistente",
    description:
      "ERRORE import riga (identita). Riga classificata INSERT_NEW ma il vendor ha gia cataloghi attivi "
      + "e block_insert_new_when_catalog_exists e attivo. Blocca la riga.",
  },
  {
    value: "Field internal_code duplicato nel feed",
    description:
      "ERRORE import riga (feed). Lo stesso internal_code compare su piu righe del feed: "
      + "viene importata solo la prima occorrenza; le successive sono scartate con errore bloccante su internal_code.",
  },
  {
    value: "Tutti i record: <motivo>",
    description:
      "Errore o warning uniforme su tutte le righe importate: il dettaglio per-riga viene compattato "
      + "in global_errors/global_warnings e la colonna Errori e Warnings replica il motivo su ogni riga visibile.",
  },
];

export const GLOBAL_IMPORT_ISSUES_LEGEND_TITLE = "Legenda errori e warning globali import";

/** Messaggi in last_run_summary.global_errors (pipeline, compattazione, elevazione da riga). */
export const GLOBAL_IMPORT_ERRORS_LEGEND = [
  {
    value: "N record con errore: <motivo>",
    description:
      "Problema di import condiviso da piu di 1000 righe: il backend compatta row_problems "
      + "e mostra qui il conteggio N con il motivo."
      + "Esempio: \"1193 record con errore: Field internal_code duplicato nel feed\". "
      + "I record compattati non compaiono piu nel pannello Import errors.",
  },
  {
    value: "Tutti i record: <motivo>",
    description:
      "Tutte le righe importate con errori condividono lo stesso motivo: i codici vanno in global_errors "
      + "e row_problems si svuota. Il preview feed replica il motivo su ogni riga visibile.",
  },
  {
    value: "name",
    description:
      "Codice campo interno (global_errors): corrisponde a \"titolo mancante\" quando l'errore e compattato "
      + "in forma codificata anziche testuale.",
  },
  {
    value: "price",
    description:
      "Codice campo interno (global_errors): corrisponde a \"prezzo mancante o uguale a 0\" quando compattato.",
  },
  {
    value: "product_url",
    description:
      "Codice campo interno (global_errors): product_url mancante o non valido quando compattato uniformemente.",
  },
  {
    value: "internal_code / ean_code",
    description:
      "Codici campo interno (global_errors): errori di identita prodotto (identificatore mancante, "
      + "codice non generabile, match ambiguo, ecc.) quando compattati come codice anziche messaggio.",
  },
  {
    value: "titolo mancante",
    description:
      "ERRORE globale (da riga o compattato). Nome/title assente dopo mapping: record scritto ma disattivato.",
  },
  {
    value: "prezzo mancante o uguale a 0",
    description:
      "ERRORE globale (da riga o compattato). Nessun prezzo valido su price/special_price: record disattivato.",
  },
  {
    value: "product_url mancante",
    description:
      "ERRORE globale (da riga o compattato). URL prodotto assente: la riga non viene importata.",
  },
  {
    value: "product_url non valido",
    description:
      "ERRORE globale (da riga o compattato). URL prodotto non http(s) valido: la riga non viene importata.",
  },
  {
    value: "identificatore mancante",
    description:
      "ERRORE globale (da riga o compattato). Mancano internal_code ed ean_code nel feed mappato.",
  },
  {
    value: "codice prodotto non generabile",
    description:
      "ERRORE globale (da riga o compattato). Impossibile costruire INT-/EAN- dagli identificatori feed.",
  },
  {
    value: "identificatore incoerente con codice prodotto",
    description:
      "ERRORE globale (da riga o compattato). Match catalogo esistente ma codice_prodotto DB incoerente col feed.",
  },
  {
    value: "match identita ambiguo",
    description:
      "ERRORE globale (da riga o compattato). Lo stesso identificatore feed matcha piu cataloghi attivi.",
  },
  {
    value: "inserimento non consentito su catalogo esistente",
    description:
      "ERRORE globale (da riga o compattato). INSERT_NEW bloccato per vendor con cataloghi attivi e flag attivo.",
  },
  {
    value: "Field internal_code duplicato nel feed",
    description:
      "ERRORE globale (da riga o elevato). Stesso internal_code su piu righe feed: importata solo la prima occorrenza.",
  },
  {
    value: "Mapping incompleto: ...",
    description:
      "ERRORE pipeline (blocca import, stato MAPPING_REVIEW). Validazione mapping fallita prima dell'import "
      + "(campi obbligatori mancanti, colonne duplicate, feed non normalizzato, ecc.).",
  },
  {
    value: "Import bloccato: revisione manuale mapping non completata ...",
    description:
      "ERRORE pipeline (MAPPING_REVIEW). Mapping non in stato MANUAL: l'import non parte finche non viene salvato manualmente.",
  },
  {
    value: "Nessun feed URL configurato",
    description: "ERRORE pipeline (FAILED). Manca l'URL del feed nel profilo vendor.",
  },
  {
    value: "Nessun feed normalizzato salvato per questo vendor",
    description:
      "ERRORE pipeline (FAILED). Import da feed normalizzato senza snapshot locale disponibile.",
  },
  {
    value: "Nessun feed raw salvato per questo vendor",
    description:
      "ERRORE pipeline (DOWNLOAD_FAILED / normalizzazione). Feed raw assente: serve download o upload manuale.",
  },
  {
    value: "<messaggio eccezione download/parsing>",
    description:
      "ERRORE pipeline (DOWNLOAD_FAILED o PARSE_FAILED). Testo libero dall'eccezione di download o parsing feed "
      + "(timeout, HTTP error, formato non riconosciuto, file corrotto, ecc.).",
  },
];

/** Messaggi in last_run_summary.global_warnings (pipeline, compattazione, elevazione da riga). */
export const GLOBAL_IMPORT_WARNINGS_LEGEND = [
  {
    value: "N record con warning: <motivo>",
    description:
      "Warning di import condiviso da piu di 1000 righe: compattazione analoga agli errori globali. "
      + "Esempio: \"1771 record con warning: immagine mancante\". "
      + "I record compattati non compaiono piu nel pannello Import warnings.",
  },
  {
    value: "Tutti i record: immagine mancante",
    description:
      "Tutte le righe importate hanno lo stesso warning immagine: compattato in global_warnings, "
      + "row_problems svuotato per quel motivo.",
  },
  {
    value: "image_path",
    description:
      "Codice campo interno (global_warnings): corrisponde a \"immagine mancante\" quando compattato come codice.",
  },
  {
    value: "immagine mancante",
    description:
      "WARNING globale (da riga o elevato). Nessun URL valido su image_path/image_path_1/image_path_2: "
      + "prodotto resta attivo ma segnalato.",
  },
  {
    value: "feed senza sconto distinto: prezzi identici nel campione",
    description:
      "WARNING pipeline (price_inference). Nel campione analizzato price e special_price coincidono sempre: "
      + "il feed sembra non avere sconto distinto.",
  },
  {
    value: "inferenza prezzi: swap automatico (...)",
    description:
      "WARNING pipeline (price_inference). Colonne price/special_price scambiate automaticamente "
      + "per allineare listino e prezzo vendita (messaggio dinamico con nomi colonna).",
  },
];

/** Messaggi prodotti da mapping_validation.py: visibili solo dopo Salva mapping. */
export const MAPPING_VALIDATION_LEGEND = [
  {
    value: "Il campo name non e mappato",
    description:
      "ERRORE validazione mapping (blocca import, stato MANUAL_ERR). Nessuna colonna feed punta al token name.",
  },
  {
    value: "Manca almeno un campo prezzo tra price e special_price",
    description:
      "ERRORE validazione mapping (blocca import). Serve almeno un token price o special_price mappato.",
  },
  {
    value: "Il campo product_url non e mappato",
    description:
      "ERRORE validazione mapping (blocca import). Ogni prodotto deve avere il link offerta sul sito vendor (DB catalog.link_offerta).",
  },
  {
    value: "Manca almeno un codice tra internal_code e ean_code",
    description:
      "ERRORE validazione mapping (blocca import). Serve almeno uno tra SKU/codice interno ed EAN/GTIN.",
  },
  {
    value: "Colonna feed URL prodotto non mappata a product_url",
    description:
      "ERRORE validazione mapping (blocca import). L'header feed sembra un link prodotto ma il token e skip o diverso da product_url. "
      + "Se product_url e gia mappato su un'altra colonna, le colonne URL duplicate possono restare su skip.",
  },
  {
    value: "Campo DB mappato su piu colonne feed",
    description:
      "ERRORE validazione mapping (blocca import). Lo stesso token e assegnato a piu colonne "
      + "(messaggio backend: Campo DB '<token>' mappato su piu colonne feed: ...).",
  },
  {
    value: "Nessuna colonna rilevata nel feed normalizzato o feed ancora non normalizzato",
    description:
      "ERRORE validazione mapping (blocca import). Il feed normalizzato non ha colonne utilizzabili oppure non e stato ancora scaricato/normalizzato.",
  },
  {
    value: "Manca almeno un campo categoria",
    description:
      "WARNING validazione mapping (non blocca import). Nessun token category/categoria/category_1..6/category_path mappato "
      + "(backend: Manca almeno un campo categoria (category, category_path, category_1, ...)).",
  },
  {
    value: "Manca almeno un campo immagine (image_path, image_path_1, image_path_2)",
    description:
      "WARNING validazione mapping (non blocca import). Nessuno slot immagine mappato; l'import puo partire ma le righe rischiano warning immagine mancante.",
  },
  {
    value: "Manca il campo shipping_price (spese di spedizione) nel mapping o nei column_defaults",
    description:
      "WARNING validazione mapping (non blocca import). Nessuna colonna mappata a shipping_price e nessun column_defaults.shipping_price: catalog.spese_di_spedizione resta vuota o ereditata dal record precedente.",
  },
];

export const buildMappingLegendItems = (fieldKeys = []) => {
  const tokens = [SKIP_FIELD_TOKEN, ...(fieldKeys || []).filter((field) => field !== SKIP_FIELD_TOKEN)];
  const unique = [];
  tokens.forEach((token) => {
    if (!unique.includes(token)) {
      unique.push(token);
    }
  });

  return unique.map((token) => ({
    token,
    description: mappingLegendDescription(token),
  }));
};
